import { useTranslation } from "react-i18next";

import { SectionHeader } from "@pentabd/ui";

import { NextButton } from "@components";

export const HeaderWithNextButton = ({
  title,
  subtitle,
  action,
  isDisabled,
}: {
  title: string;
  subtitle?: string;
  action: () => void;
  isDisabled?: boolean;
}) => {
  const { t } = useTranslation();
  
  return (
    <SectionHeader
      title={t(title)}
      subtitle={subtitle ? t(subtitle) : undefined}
      components={[
        <NextButton
          key="next_btn"
          action={action}
          disabled={isDisabled}
        />,
      ]}
    />
  );
};
